export function menuBtn() {
  $('.js-nav_btn, .p-header_nav_list_link').on('click', function () {
    $(this).toggleClass('is-active');
    $('.p-header_nav').toggleClass('is-active');
    $('.p-header').toggleClass('is-active');
  });
}